module.exports = __webpack_public_path__ + "static/media/anualidad-info.7301c4ff.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/anualidad-info.png
// module id = 85
// module chunks = 0